import MacOS from "./components/macOS";

function App() {
  return <MacOS />;
}

export default App;
